export default "__VITE_ASSET__CdbSZqRo__"